import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "km_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const http = axios.create({ baseURL: API, withCredentials: true });

http.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// An expired/invalid session should bounce to login instead of leaving the app
// stuck on a "couldn't load" state.
http.interceptors.response.use(
  (res) => res,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || "";
    if (status === 401 && !url.startsWith("/auth/")) {
      clearToken();
      if (window.location.pathname !== "/login") {
        window.location.replace("/login");
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// ---- auth ----
export const registerUser = async (payload) => {
  const { data } = await http.post("/auth/register", payload);
  return data;
};

export const loginUser = async (payload) => {
  const { data } = await http.post("/auth/login", payload);
  return data;
};

export const fetchMe = async () => {
  const { data } = await http.get("/auth/me");
  return data;
};

export const logoutUser = async () => {
  try {
    await http.post("/auth/logout");
  } catch (e) {
    /* ignore */
  }
};

export const forgotPassword = async (email) => {
  const { data } = await http.post("/auth/forgot-password", { email });
  return data;
};

export const resetPassword = async (payload) => {
  const { data } = await http.post("/auth/reset-password", payload);
  return data;
};

// ---- kids ----
export const fetchKids = async () => {
  const { data } = await http.get("/kids");
  return data;
};

export const createKid = async (name) => {
  const { data } = await http.post("/kids", { name });
  return data;
};

export const renameKid = async (kidId, name) => {
  const { data } = await http.patch(`/kids/${kidId}`, { name });
  return data;
};

export const removeKid = async (kidId) => {
  const { data } = await http.delete(`/kids/${kidId}`);
  return data;
};

// ---- account ----
export const fetchAccount = async (kidId) => {
  const { data } = await http.get(`/kids/${kidId}/account`);
  return data;
};

export const createTransaction = async (kidId, payload) => {
  const { data } = await http.post(`/kids/${kidId}/transactions`, payload);
  return data;
};

export const deleteTransaction = async (kidId, id) => {
  const { data } = await http.delete(`/kids/${kidId}/transactions/${id}`);
  return data;
};

export const createGoal = async (kidId, payload) => {
  const { data } = await http.post(`/kids/${kidId}/goals`, payload);
  return data;
};

export const deleteGoal = async (kidId, id) => {
  const { data } = await http.delete(`/kids/${kidId}/goals/${id}`);
  return data;
};
